import mojs from 'mo-js';

export class CommentEvent {

  static animateCommentsForId (buttonId, iconId, onComplete = null) {

    const button = document.getElementById(buttonId);
    const icon = document.getElementById(iconId);

    const tlDuration = 300;

    const triangleBurst = new mojs.Burst({
      parent: button,
      radius: { 30: 75 },
      count: 5,
      angle: 30,
      children: {
        shape: 'polygon',
        radius: { 4: 0 },
        scale: 2,
        fill: 'rgba(29,173,179,0.8)',
        strokeWidth: 2,
        angle: 270,
        delay: 30,
        speed: 0.2,
        easing: mojs.easing.bezier(0.1, 1, 0.3, 1),
        duration: tlDuration
      }
    });

    const scaleButton = new mojs.Html({
      el: `#${buttonId}`,
      duration: tlDuration,
      scale: { 1.3: 1 },
      easing: mojs.easing.out
    });

    button.style.transform = 'scale(1, 1)';

    const animationTimeline = new mojs.Timeline();
    animationTimeline.add([
      triangleBurst,
      scaleButton
    ]);

    function repeat () {
      animationTimeline.replay();
      if (!!icon.classList) {
        icon.classList.add('checked');
      }
    }

    repeat();
    setTimeout(() => {
      if (onComplete) {
        onComplete();
      }
    }, tlDuration + 50);

  }

}
